import { clientAppLog } from '@/app/components/search/logging/clientAppLog.ts';

/**
 * Extra `key=value` pairs to name what the missing image belongs to, so a Grafana query answers the
 * question without anyone having to read the url back (MPH-1082). Empty values are left out, and a
 * value carrying a space or a quote is quoted, logfmt style: a third of the French tour-operator
 * codes are worded — `NOUVELLES FRONTIERES` — and unquoted they would parse as a truncated value
 * followed by garbage keys, losing exactly the codes this report exists to collect.
 */
const formatContext = (context: Record<string, string | undefined>) =>
  Object.entries(context)
    .filter(([, value]) => value)
    .map(([key, value]) => {
      const needsQuotes = /[\s"]/.test(value as string);
      return `${key}=${needsQuotes ? JSON.stringify(value) : value} `;
    })
    .join('');

export const clientAppLogImageError = async (
  codeSourceName: string,
  src?: string,
  hotelId?: number | undefined,
  context: Record<string, string | undefined> = {}
) => {
  try {
    if (!src) return;

    const imageFetch = await fetch(src, { method: 'HEAD' });
    const imageStatus = imageFetch?.status;

    // Consume the response body to prevent ArrayBuffer leak
    // Even HEAD requests can have bodies in some server implementations
    await imageFetch.text().catch(() => {});

    if (imageStatus && imageStatus !== 200) {
      clientAppLog({
        level: 'WARN',
        codeSourceName,
        logMessage: `Image could not be loaded. status=${imageStatus} ${hotelId ? `hotelId=${hotelId}` : ``} ${formatContext(context)}src=${src}`,
        url: window?.location?.href,
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('[ERROR]', error);
  }
};
